import { ToastData } from './ToastData';

type ToastListener = () => void;

let toasts: ToastData[] = [];
const listeners = new Set<ToastListener>();

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const ToastStore = {
  subscribe(listener: ToastListener) {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  },
  getSnapshot(): ToastData[] {
    return toasts;
  },
  add(item: ToastData) {
    toasts = [...toasts, item];
    emit();
  },
  replace(item: ToastData) {
    toasts = [item];
    emit();
  },
  remove(id: string) {
    toasts = toasts.filter((item) => item.id !== id);
    emit();
  },
  reset() {
    toasts = [];
    emit();
  },
};
